<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.performance.version1") }}</h1>
    <Search :createAction="createAction" :searchAction="searchAction" />
    <List :tableHeaderData="tableHeaderData" :tableData="versionList" />
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
    />

    <Dialog
      :closeAction="closeDialog"
      :visible="dialogVisible"
      :confirmAction="submitVersonForm"
      :titleText="$locale('version.screen.modal.title')"
      width="660px"
    >
      <el-form ref="detailForm" :model="versionDetailData" :rules="formRules">
        <!-- <el-form-item label="test" prop="testId">
          <RemoteSelectV2
            v-model="versionDetailData.testId"
            :formValue.sync="versionDetailData.testId"
            multiple
            :list="clientList"
            @setList="list => clientList = list" />
        </el-form-item> -->
        <el-form-item :label="$locale('global.name')" prop="name">
          <el-input
            :placeholder="$locale('form.plsEnterYourName')"
            v-model="versionDetailData.name"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen.modal.onlinelabel')" prop="displayOnlineMsg">
          <el-input v-model="versionDetailData.displayOnlineMsg"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen.modal.poslabel')" prop="displayPosMsg">
          <el-input v-model="versionDetailData.displayPosMsg"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen.modal.cclabel')" prop="displaySelfCashierMsg">
          <el-input
            v-model="versionDetailData.displaySelfCashierMsg"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.national.ticket.id')" prop="code">
          <el-input v-model="versionDetailData.code" maxlength="2"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('version.screen,header.signage')" prop="displaySignage">
          <el-select
            v-model="versionDetailData.displaySignage"
          >
            <el-option :label="$locale('global.yes')" :value="true" />
            <el-option :label="$locale('global.no')" :value="false" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="説明">
          <el-input
            type="textarea"
            v-model="versionDetailData.description"
          ></el-input>
        </el-form-item> -->
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import "@/assets/style/versionManagement.less";
import Dialog from "@/components/Version/dialog.vue";
import Search from "@/components/Version/search.vue";
import CommPagination from "@/components/common/CommPagination";
import List from "@/components/Version/list.vue";
import {
  getVersionService,
  delVersionService,
  addVersionService,
  updateVersionService,
} from "@/helpers/service/api/version";
import countDownAlert from "@/utils/countDownAlert";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";

export default {
  components: {
    Search,
    Dialog,
    CommPagination,
    List,
    RemoteSelectV2
  },
  data() {
    return {
      cinemaId: window.localStorage.getItem("cinemaId"),
      dialogVisible: false,
      versionDetailData: {
        description: "",
        displayOnlineMsg: "",
        displayPosMsg: "",
        displaySelfCashierMsg: "",
        displaySignage: true,
        id: "",
        name: "",
        testId: "",
      },
      versionList: [],
      count: 0,
      currentPage: 0,
      searchFilter: {},
      tableHeaderData: [
        {
          prop: "name",
          label: this.$locale("global.name"),
          width: 160,
        },
        {
          prop: "code",
          label: this.$locale("version.national.ticket.id"),
          width: 100,
        },
        {
          label: this.$locale("version.screen.header.pos"),
          prop: "displayPosMsg",
          width: 120,
        },
        {
          label: this.$locale("version.screen.header.net"),
          prop: "displayOnlineMsg",
          width: 120,
        },
        {
          label: this.$locale("version.screen.header.cc"),
          prop: "displaySelfCashierMsg",
          width: 120,
        },
        {
          label: this.$locale("version.screen,header.signage"),
          prop: "displaySignage",
          width: 120,
          formatter: (row, column, cellValue) => {
            return this.boolMapping(cellValue);
          }
        }
      ],
      isUpdate: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourName")
          }
        ],
      },
      clientList: []
    };
  },
  created() {
    if (!this.cinemaId) {
      this.$emit("callCinema", "getVersionList");
      return;
    }
    this.getVersionList();
    getClientListService({
      page: 0,
      pageSize: 10
    }).then(res => {
      this.clientList = res.data.data;
    });
  },
  methods: {
    delVersionItem(vid) {
      if (!vid) {
        return;
      }

      delVersionService({ vid }).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.deleteSuccessfully"),
            callback: () => {
              this.getVersionList();
            }
          });
        }
      });
    },
    getVersionList() {
      getVersionService({
        cinemaId: this.cinemaId,
        page: this.currentPage,
        ...this.searchFilter
      }).then(res => {
        this.versionList = res.data.data;
        this.count = res.data.count;
      });
    },
    pageChange(value) {
      if (!value) {
        return;
      }

      this.currentPage = value - 1;
      this.getVersionList();
    },
    createAction() {
      this.isUpdate = false;
      this.openDialog();
    },
    editAction(context) {
      this.isUpdate = true;
      this.versionDetailData = { ...context };
      this.openDialog();
    },
    delAction(context) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">
        ${this.$locale(context.name)} ${this.$locale("version.screen.action.del")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          this.delVersionItem(context.id);
        });
    },
    searchAction(name) {
      if (name) {
        this.searchFilter.name = name;
      } else {
        this.searchFilter = {};
      }

      this.getVersionList();
    },
    submitVersonForm() {
      const requestParam = {
        ...this.versionDetailData,
        cinemaId: this.cinemaId,
      };
      const requestScuessFn = (res, countDownText) => {
        if (!res.success) { return; }
        this.closeDialog();

        countDownAlert({
          content: countDownText,
          callback: () => {
            this.getVersionList();
          }
        });
      };

      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (!this.isUpdate) {
            addVersionService(requestParam).then(res => {
              requestScuessFn(res, this.$locale("global.createSuccessfully"));
            });
          } else {
            updateVersionService(requestParam).then(res => {
              requestScuessFn(res, this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          setTimeout(()=>{
            const isError= document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.versionDetailData = {
        cinemaId: this.cinemaId,
        description: "",
        displayOnlineMsg: "",
        displayPosMsg: "",
        displaySelfCashierMsg: "",
        id: "",
        name: ""
      };
      this.$refs.detailForm.clearValidate();
      this.dialogVisible = false;
    },
    boolMapping(cellValue) {
      return cellValue ? this.$locale("global.yes") : this.$locale("global.no");
    }
  },
};
</script>
